import { PerformedByRequestDTO } from './performed-by-request-dto';

export interface UpdateB2CRequestDTO extends PerformedByRequestDTO {
    userEmail?: string;
}
